import React from 'react';
import { isEqual } from 'lodash';
import { Column } from '../../kit/interface';
import { SpreadsheetGridRow } from '../../../styles';

import SpreadsheetCell from './cell';

interface Props {
  x: number;
  maxX: number;
  columns: Column[];
  row: any;
  onCellClick?: (x: number, y: number, row: any, columnId: number, e: any) => void;
  onCellDoubleClick?: (x: number, y: number) => void;
  activeCell?: { x: number; y: number } | null;
  focusedCell?: { x: number; y: number } | null;
  getCellClassName?: (column: Column, row: any, x: number, y: number) => string;
  disabledCells?: { x: number; y: number }[];
  height?: number;
  columnWidthValues?: { [key in string | number]: number };
}

class SpreadsheetRow extends React.Component<Props, {}> {
  shouldComponentUpdate(nextProps: any) {
    const currentActiveCell = this.props.activeCell;
    const nextActiveCell = nextProps.activeCell;
    const currentFocusedCell = this.props.focusedCell;
    const nextFocusedCell = nextProps.focusedCell;

    const isActiveCellChanged =
      (currentActiveCell && !nextActiveCell) ||
      (!currentActiveCell && nextActiveCell) ||
      (currentActiveCell &&
        nextActiveCell &&
        (currentActiveCell.x !== nextActiveCell.x || currentActiveCell.y !== nextActiveCell.y));

    const isFocusedCellChanged =
      (currentFocusedCell && !nextFocusedCell) ||
      (!currentFocusedCell && nextFocusedCell) ||
      (currentFocusedCell &&
        nextFocusedCell &&
        (currentFocusedCell.x !== nextFocusedCell.x || currentFocusedCell.y !== nextFocusedCell.y));

    return (
      this.props.row !== nextProps.row ||
      this.props.x !== nextProps.x ||
      JSON.stringify(this.props.disabledCells) !== JSON.stringify(nextProps.disabledCells) ||
      this.props.columns !== nextProps.columns ||
      this.props.columnWidthValues !== nextProps.columnWidthValues ||
      (!!isActiveCellChanged &&
        ((currentActiveCell && currentActiveCell.x === this.props.x) ||
          (nextActiveCell && nextActiveCell.x === this.props.x))) ||
      (!!isFocusedCellChanged &&
        ((currentFocusedCell && currentFocusedCell.x === this.props.x) ||
          (nextFocusedCell && nextFocusedCell.x === this.props.x)))
    );
  }

  render() {
    const {
      x,
      maxX,
      height,
      columns,
      row,
      onCellClick,
      onCellDoubleClick,
      getCellClassName,
      activeCell,
      focusedCell,
      columnWidthValues,
    } = this.props;

    return (
      <SpreadsheetGridRow className="SpreadsheetGrid__row" height={height || 0}>
        {columns.map((column, y) => {
          const coords = { x, y };
          const disabled = !!this.props.disabledCells?.find((cell) => {
            return cell.x === x && cell.y === y;
          });
          const id = x === y ? 'q3-first-cell' : maxX - 1 === x && y + 1 === columns.length ? 'q3-last-cell' : '';
          return (
            <SpreadsheetCell
              id={id}
              y={y}
              key={y}
              className={getCellClassName && getCellClassName(column, row, x, y)}
              onClick={!disabled ? onCellClick?.bind(this, x, y, row,Number(column.id)) : null}
              onDoubleClick={!disabled ? onCellDoubleClick?.bind(this, x, y) : null}
              width={columnWidthValues && columnWidthValues[column.id]}
            >
              {
                // @ts-ignore
                column.value(row, {
                  active: isEqual(activeCell, coords),
                  focus: isEqual(focusedCell, coords),
                  disabled,
                })
              }
            </SpreadsheetCell>
          );
        })}
      </SpreadsheetGridRow>
    );
  }
}

export default SpreadsheetRow;
